<template>
  <div class="auth-page">
    <div class="wrapper">
      <transition name="slide-from-right" mode="out-in">
        <KeepAlive>
          <NLogin
            v-if="$route.params.type === 'login'"
            @change-form="changeForm"
            @login="login"
            class="auth-page__form"
          />

          <NRegister
            v-else-if="$route.params.type === 'registration'"
            @change-form="changeForm"
            @register="register"
            class="auth-page__form"
          />

          <NRestorePassword
            v-else-if="$route.params.type === 'restorePassword'"
            @change-form="changeForm"
            @send-email="sendVerificationEmail"
            class="auth-page__form"
          />

          <AuthCodeVeification
            v-else-if="$route.params.type === 'codeVerification'"
            @change-form="changeForm"
            @approve-code="approveCode"
            class="auth-page__form"
          />

          <NAuthEmailVeification
            v-else-if="$route.params.type === 'codeEmailVerification'"
            @change-form="changeForm"
            @approve-email-code="approveEmailCode"
            class="auth-page__form"
          />

          <NAuthEmailUnsubscribeVeification
            v-else-if="
              $route.params.type === 'codeEmailUnsubscribeVerification'
            "
            @change-form="changeForm"
            @approve-email-unsubscribe-code="approveEmailUnsubscribeCode"
            class="auth-page__form"
          />

          <NUnsubscribeVeification
              v-else-if="
              $route.params.type === 'codeUnsubscribeVerification'
            "
              @change-form="changeForm"
              @approve-unsubscribe-code="approveUnsubscribeCode"
              class="auth-page__form"
          />
        </KeepAlive>
      </transition>
    </div>
  </div>
</template>

<script>
import { t } from "@/utils/translate";

import { usePopupStore } from "@/store/popupStore";
import { useUserStore } from "@/store/userStore";

import { useRouter } from "vue-router";
import { customStorage } from "@/service/customStorage";

import NLogin from "@/components/NLogin.vue";
import NRegister from "@/components/NRegister.vue";
import NRestorePassword from "@/components/NRestorePassword.vue";

import AuthCodeVeification from "@/components/AuthCodeVeification.vue";
import NAuthEmailVeification from "@/components/NAuthEmailVeification";
import NAuthEmailUnsubscribeVeification from "@/components/NAuthEmailUnsubscribeVeification";

import { capitalizeFirstLetter } from "@/utils/common";
import { customAxios } from "@/service/customAxios";
import { onMounted } from "vue";
import { storeToRefs } from "pinia";
import NUnsubscribeVeification from "@/components/NUnsubscribeVeification.vue";
// import { storeToRefs } from "pinia";

export default {
  components: {
    NUnsubscribeVeification,
    NLogin,
    NRegister,
    NRestorePassword,
    AuthCodeVeification,
    NAuthEmailVeification,
    NAuthEmailUnsubscribeVeification,
  },
  setup() {
    const router = useRouter();
    const { showPopup } = usePopupStore();
    const userStore = useUserStore();
    const { setUser, setToken, setRefreshToken } = userStore;
    const { userToken } = storeToRefs(userStore);

    function changeForm(type) {
      router.push({ path: `/auth/${type}` });
    }

    async function register({ firstName, lastName, email, password, politicChecked, userAgreeChecked }) {
      console.log(firstName, lastName, email, password);
      try {
        const r = await customAxios.post("auth/signup", {
          firstName: capitalizeFirstLetter(firstName),
          lastName: capitalizeFirstLetter(lastName),
          personEmail: email,
          password: password,
          userAgreement:userAgreeChecked,
          userPersonalDataAgree:politicChecked
        });

        if (r.status === 201) {
          showPopup(
            "Вы успешно зарегистрировались! На электронную почту отправлена ссылка для активации учетной записи!",
            "success"
          );
          changeForm("login");
          return r.data;
        }

        if (r.status === 207) {
          
          throw new Error(r.data.message);
        }

        showPopup("Вы успешно зарегистрировались", "success");

        changeForm("login");
      } catch (e) {
        showPopup(e.message, "error");
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        }
      }
    }

    async function login({ username, password }) {
      try {
        const r = await customAxios.post("auth/signin", {
          username: username,
          password: password,
        });

        if (r.status === 200) {
          setUser(r.data);
          setToken(r.data.token)
          setRefreshToken(r.data.refreshToken)
          showPopup("Вы успешно вошли в систему", "success");
          router.push({ path: "/user/account" });
        }
      } catch (e) {
        if (e.response.status === 401) {
          showPopup("Не верный логин или пароль", "error");
        }
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        }

      }
    }

    async function sendVerificationEmail(email) {
      try {
        await customAxios.post("auth/password_req_get_code", {
          userEmailForRequest: email,
          uuid: null,
        });

        customStorage.set("cached-email", email);
        showPopup("Email с кодом отправлен", "success");
        changeForm("codeVerification");
      } catch (e) {
        console.log("e:" + e)
        let errorMessage = "Код не отправлен";
        showPopup(errorMessage, "error");

        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        }

      }
    }

    async function approveCode(code) {
      try {
        await customAxios.post("auth/password_req", {
          userEmailForRequest: null,
          uuid: code,
        });
        showPopup("Email с новым паролем отправлен", "success");
        changeForm("login");
      } catch (e) {
        showPopup(e.message, "error");
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        }

      }
    }

    async function approveEmailCode(code) {
      try {
        console.log("codde: " + code)
       const r  = await customAxios.post("auth/email_confirm", {uuid: code});
          console.log(r);
          if (r.status === 202) {
            await setUser(r.data);
            await setToken(r.data.token)
            showPopup("Учетная запись успешно активированна! Сейчас Вы будете перенаправлены на главную страницу", "success");
            await router.push({ path: "/" });
          } else if (r.status === 207) {
            showPopup("Не верный код активации!", "error");
          } else {
            console.log(r);
          }

      } catch (e) {
        showPopup(e.message, "error");
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        }

      }
    }
    async function approveEmailUnsubscribeCode(code) {
      try {
        await customAxios.post("auth/unsubscribe", {uuid: code} ).then((response) => {
          console.log(response);
          if (response.status === 202) {
            showPopup("Уведомления успешно отключены!", "success");
            changeForm("login");
          } else if (response.status === 207) {
            showPopup(response.data.message, "error");
          } else {
            console.log(response);
          }
        });
      } catch (e) {
        showPopup(e.message, "error");
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        }

      }
    }

    async function approveUnsubscribeCode(code) {
      try {
        await customAxios.get("unsubscribe/notification/" + code).then((response) => {
          console.log(response);
          if (response.status === 202) {
            showPopup("Уведомления успешно отключены!", "success");
            changeForm("login");
          } else if (response.status === 207) {
            showPopup(response.data.message, "error");
          } else {
            console.log(response);
          }
        });
      } catch (e) {
        showPopup(e.message, "error");
        if(e.response && e.response.data && e.response.data.message){
          showPopup(e.response.data.message, "error");
        }

      }
    }

    onMounted(() => {
      console.log(userToken.value);
      // if (userToken.value) {
      //   router.push('/user/account')
      // }
    })

    return {
      sendVerificationEmail,
      changeForm,
      t,
      register,
      login,
      approveCode,
      approveEmailCode,
      approveEmailUnsubscribeCode,
      approveUnsubscribeCode
    };
  },
};
</script>

<style lang="scss">
// https://www.headspace.com/login
.auth-page {
  .wrapper {
    @include page;
  }
}
</style>
